export const DROPDOWN_TRANSITION_TIME = "0.5s";